import React from 'react';
import type { PleriRoiReport } from '../../../../../api/pleri-roi-reports';

import { useTranslation } from 'react-i18next';
import { formatLocale } from '@plerionhq/design-system';

function formatMonthLabel(month: string | undefined | null): string {
  if (month == null || typeof month !== 'string') {
    return '';
  }
  const parts = month.split('-').map(Number);
  const y = parts[0];
  const m = parts[1];
  if (y == null || m == null || Number.isNaN(y) || Number.isNaN(m)) {
    return month;
  }
  const date = new Date(y, m - 1, 1);
  return date.toLocaleDateString(formatLocale(), {
    month: 'long',
    year: 'numeric',
  });
}

function formatGeneratedAt(iso: string | undefined | null): string {
  if (iso == null || typeof iso !== 'string') {
    return '';
  }
  try {
    const d = new Date(iso);
    return d.toLocaleString(undefined, {
      dateStyle: 'medium',
      timeStyle: 'short',
    });
  } catch {
    return iso;
  }
}

interface RoiReportMetaProps {
  report: PleriRoiReport;
}

/**
 * Displays month and generatedAt for a single report (no summary).
 */
export const RoiReportMeta: React.FC<RoiReportMetaProps> = ({ report }) => {
  const { t } = useTranslation('pleri/settings');
  return (
    <div className="space-y-1 border-b border-gray-200 pb-4 dark:border-gray-700">
      <h2 className="text-xl leading-tight font-semibold text-gray-900 dark:text-gray-100">
        {formatMonthLabel(report?.month)}
      </h2>
      <p className="text-sm text-gray-500 dark:text-gray-400">
        {t('generatedAt', { time: formatGeneratedAt(report?.generatedAt) })}
      </p>
    </div>
  );
};
